import {useManufacturerContext} from '../../context/ManufacturerContext';
import {ProductSwiper} from '../../../common/ui/ProductSwiper';
import React from 'react';
import {mapRemoteData} from '../../../common/domain/RemoteData.model';
import {fetchAllBis} from "../../../features/catalog/infrastructure/CatalogService";

export const ManufacturerProducts = () => {
  const { details } = useManufacturerContext();

  if (details?.codigo) {
    const fetchFn = () =>
      fetchAllBis({ manufacturerIds: [details.id] }, { amount: 50, page: 0 })
      .then(rd => mapRemoteData(rd, ({ content }) => content));
    return (
      <ProductSwiper title="PRODUCTOS DEL FABRICANTE" fetchFn={fetchFn} />
    );
  }
};